import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class ConfigService {
  private configs: any;
  private currentEnv: string;

  constructor(private http: HttpClient) {
    this.configs = environment;
  }

  getConfig(key: string): string {
    return this.configs[key];
  }

  getConfigObject(key: string):any{
    return this.configs[key];
  }

  getAuthConfigs() : Promise<any> {
    return this.http.get(`${environment.apis.thirdParty}/vsp-auth/configs`).toPromise();
  }

  getAuthConfigsGAME() : Promise<any> {
    return this.http.get(`${environment.apis.thirdParty}/vsp-auth/configs-game`).toPromise();
  }
}